import { t } from '@lingui/macro'
import { useNavigate } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'
import { breakpoints } from '@/config/layout'
import { useHideNativeNavigation } from '@/layout/providers/LayoutProvider'
import { CareQuestionDetailContentLayout } from '@/modules/care-question/components/care-question-detail-content-layout/CareQuestionDetailContentLayout'

export const ComingSoonPage = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  useHideNativeNavigation()

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleClose = () => {
    navigate('/', { replace: true })
  }

  return (
    <CareQuestionDetailContentLayout
      header={{
        primaryAction: {
          label: t({
            id: 'globals.go-back',
            message: 'Terug',
          }),
          icon: ['far', 'chevron-left'],
          onClick: handleGoBack,
        },
        secondaryAction: {
          label: t({
            id: 'globals.close',
          }),
          icon: ['fal', 'times'],
          onClick: handleClose,
        },
      }}
      bottom={
        <Button variant='Primary' onClick={handleClose}>
          {t({
            id: 'globals.close',
            message: 'Sluiten',
          })}
        </Button>
      }
    >
      <StContentContainer gap={theme.UI.Spacing.Space6}>
        <H2 noMargin>
          {t({
            id: 'care-question.coming-soon.title',
            message: 'Deze functionaliteit is binnenkort beschikbaar.',
          })}
        </H2>

        <P type='BodyMediumRegular' style={{ fontWeight: 400 }}>
          {t({
            id: 'care-question.coming-soon.description',
            message:
              'Neem contact op met het secretariaat van je zorgverlener of dienst of maak een afspraak online indien je vragen hebt voor jouw medisch team.',
          })}
        </P>
      </StContentContainer>
    </CareQuestionDetailContentLayout>
  )
}

const StContentContainer = styled(FlexColumn)`
  justify-content: flex-end;
  flex-grow: 1;

  @media (${breakpoints.fromS}) {
    justify-content: flex-start;
  }
`
